import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ShopInnerBanner from "./ShopInnerBanner";

import { UiBannerBottomBar } from "../../../../_uiComponents/common/UiBannerBottomBar";
import {
    UiContentWr,
    UiContentCol,
} from "../../../../_uiComponents/common/UiPageElements";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../../_uiComponents/grid-container/GridContainer";
import UiContentCard from "../../../../_uiComponents/cards/UiContentCard";
// import Nike from "../../../styles/img/favourites/nike.jpg";
import ShopFilter from "./ShopFilter";
import {
    shopBrowseProductsRequest,
    campaignVoucherAddToFavouriteRequest,
} from "../../../../../_redux/_actions";
// import { kFormatter } from "../../../_helpers/support.services";
import IconFilter from "../../../../../styles/img/icon-filter.png";
import IconClose from "../../../../../styles/img/icon-close.png";

import {
    UiBottomNavBar,
    UiBottomNavBarItem,
} from "../../../../_uiComponents/common/UiBottomNavBar";

// import TodoIcon from "../../../styles/img/bottom-nav-todo.png";
// import RewardsIcon from "../../../styles/img/bottom-nav-rewards.png";
// import HelpIcon from "../../../styles/img/help-icon.png";
// import BottomNavIcon from "../../../styles/img/bottom-nav-campaigns.png";

// import Drawer from "./views/Drawer";
import TodayTopPicks from "./TodayTopPicks";
import { DebounceInput } from "react-debounce-input";
import UiFiterInput from "../../../../_uiComponents/form/UiFilterInput";
import { UiSlider } from "../../../../_uiComponents/common/UiSlider";
// import {
//     UiNextArrow,
//     UiPrevArrow,
// } from "../../_uiComponents/common/UiSliderArrows";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import TopHeader from "../../../../_uiComponents/common/custom/header/CustomTopHeader";
import Footer from "../../../../_uiComponents/common/custom/footer/CustomFooter";

export default function CustomBrowseProducts() {
    const actionDispatch = useDispatch();
    const isFirstRender = useRef(true);
    const [isDrawerShowing, setDrawerShowing] = useState(false);

    const handleToggleDrawer = () => {
        setDrawerShowing(!isDrawerShowing);
    };

    const [filters, setFilters] = useState([]);
    const [category, setCategory] = useState([]);
    const [maxPoint, setMaxPoint] = useState(1000000);
    const [pointBudget, setPointBudget] = useState({});
    const [userRatings, setUserRatings] = useState([]);
    const [searchString, setSearchString] = useState("");

    const setPointBudgetValues = (values, index) => {
        let newValues = { ...pointBudget, [index]: values };
        setPointBudget(newValues);
    };

    const UiMainSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    const removePointBudgetValues = (index) => {
        let newValues = { ...pointBudget };
        delete newValues[index];

        setPointBudget(newValues);
    };

    const navigate = useNavigate();

    const { browseProducts } = useSelector((state) => {
        return {
            browseProducts: state.shop.browseProducts.vouchers,
        };
    });

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (!isFirstRender.current) {
            getData();
        }
        isFirstRender.current = false;
    }, [filters, category, maxPoint, pointBudget, userRatings, searchString]);

    const selectFilters = (id) => {
        let selectedFilters = [...filters];
        if (selectedFilters.includes(id)) {
            selectedFilters = selectedFilters.filter((filter) => filter != id);
        } else {
            selectedFilters.push(id);
        }

        setFilters(selectedFilters);
    };

    const selectCategories = (id) => {
        let selectedCategories = [...category];
        if (selectedCategories.includes(id)) {
            selectedCategories = selectedCategories.filter(
                (cate) => cate != id,
            );
        } else {
            selectedCategories.push(id);
        }

        setCategory(selectedCategories);
    };

    const setMaxPointSlider = (points) => {
        setMaxPoint(points);
    };

    const selectUserRatings = (rate) => {
        let selectedUserRatings = [...userRatings];

        const index = selectedUserRatings.indexOf(rate);

        if (index > -1) {
            selectedUserRatings.splice(index, 1);
        } else {
            selectedUserRatings.push(rate);
        }

        setUserRatings(selectedUserRatings);
    };

    const getData = () => {
        let pointRequest = {};

        if (maxPoint != 50) {
            pointRequest = {
                minPoints: 50,
                maxPoints: maxPoint,
            };
        }

        actionDispatch(
            shopBrowseProductsRequest({
                selectedFilters: filters,
                selectedCategories: category,
                budgetPoints: Object.values(pointBudget),
                ratings: userRatings,
                pageNumber: 1,
                pageSize: 100,
                searchText: searchString,
                ...pointRequest,
            }),
        );
    };

    const readMore = (id) => {
        navigate("/app/shop/" + id);
    };

    return (
        <>
            <div className="sb-renault-wr">
                <UiMainWrapper>
                    <TopHeader />
                    <ShopInnerBanner
                        title="Reward Shop"
                        description="Take a moment and browse."
                    />
                    <div className="sb-banner-bottom-shop">
                        <UiBannerBottomBar
                            prevPage="Shop"
                            prevPageLink="/app/shop/browse-products"
                            currentPage={"Broswe All Products"}
                            currentPageLink={"/app/shop/browse-products"}
                        />
                    </div>
                    <div className="sb-top-text-slider">
                        <UiSlider UiSliderSettings={UiMainSlider}>
                            <div style={{ width: 130 }}>
                                Travel & Experience{" "}
                            </div>
                            <div style={{ width: 60 }}>Fashion </div>
                            <div style={{ width: 80 }}>Groceries </div>
                            <div style={{ width: 80 }}>Electricals </div>
                            <div style={{ width: 110 }}>Health & Beauty </div>
                            <div style={{ width: 60 }}>Kids </div>
                            <div style={{ width: 120 }}>Sport & Leisure </div>
                            <div style={{ width: 120 }}>Home & Garden</div>
                        </UiSlider>
                    </div>
                    {/* <ul className="sb-favourite-mobile">
                               <li>Travel & Experience</li> 
                               <li>Fashion</li> 
                               <li>Groceries</li> 
                               <li> Electricals</li> 
                               <li> Health & Beauty</li> 
                               <li>Kids</li> 
                               <li> Sport & Leisure</li> 
                               <li>Home & Garden</li> 
                            </ul> */}

                    <UiContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiCol lg="4" xl="3" className="sb-filter-wr">
                                <UiContentCol>
                                    <div
                                        className="sb-float-filter"
                                        onClick={handleToggleDrawer}
                                    >
                                        {isDrawerShowing ? (
                                            <img src={IconClose} />
                                        ) : (
                                            <img src={IconFilter} />
                                        )}
                                    </div>

                                    <ShopFilter
                                        show={isDrawerShowing}
                                        selectFilters={selectFilters}
                                        selectCategories={selectCategories}
                                        setMaxPointSlider={setMaxPointSlider}
                                        setPointBudgetValues={
                                            setPointBudgetValues
                                        }
                                        removePointBudgetValues={
                                            removePointBudgetValues
                                        }
                                        selectUserRatings={selectUserRatings}
                                        setSearchString={setSearchString}
                                    />
                                </UiContentCol>
                            </UiCol>

                            <UiCol lg="8" xl="9" id="product">
                                <UiCol lg="12"></UiCol>
                                <TodayTopPicks />
                                <div className="sb-products-list-wr">
                                    <UiContentCol>
                                        <UiSingleRow>
                                            <UiCol lg="12">
                                                {/* <Form
                                     onSubmit={onSubmit}
                                        validate={validate}
                                         render={({ handleSubmit }) => (
                                    <form onSubmit={handleSubmit}>
                                        <UiInput type="text" name="search" placeholder="Search Transactions"/>
                                    </form>
                        )}
                   /> */}
                                            </UiCol>
                                            <UiCol
                                                lg="12"
                                                className="sb-mobile-rewards-search"
                                            >
                                                <DebounceInput
                                                    placeholder={
                                                        "Search Rewards"
                                                    }
                                                    minLength={2}
                                                    debounceTimeout={500}
                                                    onChange={(event) => {
                                                        setSearchString(
                                                            event.target.value,
                                                        );
                                                    }}
                                                    element={UiFiterInput}
                                                />
                                            </UiCol>
                                            <UiCol
                                                lg="12"
                                                className="sb-popular-choices-title"
                                            >
                                                <h4>Popular choices</h4>
                                            </UiCol>
                                            {browseProducts.map(
                                                (browseProduct, index) => (
                                                    <UiCol
                                                        key={index}
                                                        lg="3"
                                                        className="col-6"
                                                    >
                                                        <UiContentCard
                                                            voucherId={
                                                                browseProduct.id
                                                            }
                                                            onClick={() =>
                                                                readMore(
                                                                    browseProduct.id,
                                                                )
                                                            }
                                                            cardImg={
                                                                browseProduct.imageUrl
                                                            }
                                                            rating={
                                                                browseProduct.rating
                                                            }
                                                            reviews={
                                                                browseProduct.ratingCount
                                                            }
                                                            heading={
                                                                browseProduct.header
                                                            }
                                                            footer="true"
                                                            bottomIcon="true"
                                                            body={
                                                                browseProduct.body
                                                            }
                                                            // points={kFormatter(
                                                            //     browseProduct.points,
                                                            // )}

                                                            isFavourite={
                                                                browseProduct.isFavourite
                                                            }
                                                        />
                                                    </UiCol>
                                                ),
                                            )}
                                        </UiSingleRow>
                                    </UiContentCol>
                                </div>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr>
                    <UiBottomNavBar />
                    <Footer />
                </UiMainWrapper>
            </div>
        </>
    );
}
